import { render, staticRenderFns } from "./JobSearch.vue?vue&type=template&id=cee0812c&lang=pug"
import script from "./JobSearch.vue?vue&type=script&lang=ts"
export * from "./JobSearch.vue?vue&type=script&lang=ts"
import style0 from "./JobSearch.vue?vue&type=style&index=0&id=cee0812c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./JobSearch.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FQuestionnaire%2Fcomponents%2FAnswerBlocks%2Fcomponents%2FJobSearch.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports